import { ShieldCheck, PackageCheck, Search, RotateCcw } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "react-router-dom";

const steps = [
  { icon: PackageCheck, title: "Distribuidores oficiales", desc: "Compramos únicamente a canales autorizados por las casas perfumistas." },
  { icon: Search, title: "Verificación de lote", desc: "Cada lote es revisado antes de entrar en almacén: sello, código, atomizador y packaging." },
  { icon: ShieldCheck, title: "Trazabilidad completa", desc: "Cada frasco lleva un número de lote registrado que puedes comprobar antes de abrir." },
  { icon: RotateCcw, title: "Garantía de reembolso", desc: "Si algo no encaja con el producto oficial, te devolvemos el 100% del importe." },
];

const faqs = [
  { q: "¿Cómo puedo verificar la originalidad?", a: "Cada perfume tiene un número de lote (indicado en la ficha de producto) impreso también en la caja y frasco. Deben coincidir. Además, comprueba el peso del cristal, la nitidez de las tipografías y la calidad del atomizador." },
  { q: "¿Vendéis testers o miniaturas?", a: "Solo si están indicados explícitamente en la ficha. Los testers reales son productos oficiales originales — no imitaciones." },
  { q: "¿Qué pasa si dudo de la autenticidad?", a: "Escríbenos con fotos del producto. Si detectamos cualquier anomalía, recogemos el pedido gratis y te reembolsamos el 100%." },
  { q: "¿Cuánto tarda la devolución?", a: "Tienes 30 días desde la recepción. Los reembolsos se procesan en un máximo de 5 días laborables tras recibir la devolución." },
];

export default function Authenticity() {
  return (
    <div>
      <section className="bg-navy text-cream py-24 md:py-32">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <div className="font-mono-caps text-gold mb-6">Nuestra garantía</div>
          <h1 className="font-serif text-5xl md:text-7xl leading-[1] max-w-3xl">
            Perfumes<br /><span className="italic">100% originales.</span>
          </h1>
          <p className="mt-8 max-w-2xl text-white/70 text-lg leading-relaxed">
            Todos nuestros perfumes son 100% originales. No vendemos imitaciones ni testers sin indicación. Trabajamos con distribuidores oficiales y verificamos cada lote. Garantía de autenticidad o te devolvemos tu dinero.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <h2 className="font-serif text-4xl md:text-5xl mb-12">Nuestro proceso</h2>
          <div className="grid md:grid-cols-2 gap-8">
            {steps.map((s, i) => (
              <div key={s.title} className="border border-border p-8 md:p-10" data-testid={`auth-step-${i}`}>
                <s.icon strokeWidth={1} className="h-10 w-10 text-navy" />
                <div className="font-mono-caps text-xs text-muted-foreground mt-6">Paso {String(i + 1).padStart(2, "0")}</div>
                <h3 className="font-serif text-2xl mt-2">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28 bg-muted">
        <div className="max-w-[900px] mx-auto px-6 lg:px-12">
          <h2 className="font-serif text-4xl md:text-5xl mb-10">Preguntas frecuentes</h2>
          <Accordion type="single" collapsible>
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`f${i}`}>
                <AccordionTrigger className="font-serif text-xl text-left">{f.q}</AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-muted-foreground">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      <section className="py-24 text-center">
        <h3 className="font-serif text-3xl md:text-4xl">¿Aún tienes dudas?</h3>
        <p className="text-muted-foreground mt-3">Nuestro equipo experto responde en menos de 4h.</p>
        <Link to="/contacto" className="inline-block mt-8 bg-navy text-cream px-8 py-4 font-mono-caps hover:bg-cream hover:text-navy transition-colors">Contactar</Link>
      </section>
    </div>
  );
}
